<template>
  <div id="constructionWaste">
    <div class="main">
        <div class="nav-bar">
          <div class="nav-bar-l">
            <p>建筑垃圾</p>
          </div>
          <div class="nav-bar-r">
            <el-dropdown trigger="click">
              <div class="el-dropdown-link">
                参数设置
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>A站点</el-dropdown-item>
                <!-- <el-dropdown-item>B站点</el-dropdown-item> -->
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown trigger="click">
                <div class="el-dropdown-link">
                  历史数据统计
                </div>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>开启</el-dropdown-item>
                  <el-dropdown-item>关闭</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
          </div>
        </div>
        <div class="scroll-big">
          <div class="map">
          <div class="map-l">
            <baidu-map style="width: 100%;height: 100%;border-radius: 6px;" :center="center" :zoom="14" @ready="handler" :mapClick="false">
               <bm-marker :position="center">
               </bm-marker> 
            </baidu-map>
          </div>
          <div class="map-r">
            <div class="map-r-title">站点情况</div>
            <div class="map-r-content">
              <div class="item"  @click="enterDetails">
                <span>A站点</span>
                <span>正常</span>
              </div>
    
              <!-- <div>12431231</div>
              <div>12431231</div>
              <div>12431231</div>
              <div>12431231</div>
              <div>12431231</div>
              <div>12431231</div>
              <div>12431231</div>
              <div>12431231</div>
              <div>12431231</div>
              <div>12431231</div>
              <div>12431231</div> -->
            </div>
            </div>
          </div>
        </div>
        <div class="box">
          <div class="box-top">周数据汇报</div>
          <div class="box-bottom">
            <div class="title">
              <div class="title-item">
                时间
              </div>
              <div class="title-item">
                站点
              </div>
              <div class="title-item">
                实拍
              </div>
              <div class="title-item">
                限定面积
              </div>
              <div class="title-item">
                占地面积
              </div>
              <div class="title-item">
                状态
              </div>
            </div>
            <div class="scroll">
              <!-- <div class="content-i">
                  <div class="content-item">2022-9-21</div>
                  <div class="content-item">A站点</div>
                  <div class="content-item" style="padding: 4px;"><img style="width: 100%;height: 100%;" src="../../assets/image/rubbish.png"></div>
                  <div class="content-item">80m²</div>
                  <div class="content-item">65m²</div>
                  <div class="content-item">正常</div>
              </div> -->
              <div class="content-i">
                  <div class="content-item">2022-11-15</div>
                  <div class="content-item">A站点</div>
                  <div class="content-item" style="padding: 4px;"><img style="width: 100%;height: 100%;" src="../../assets/image/rubbish2.png"></div>
                  <div class="content-item">80m²</div>
                  <div class="content-item">76m²</div>
                  <div class="content-item">正常</div>
              </div>
              <div class="content-i">
                  <div class="content-item">2022-11-18</div>
                  <div class="content-item">A站点</div>
                  <div class="content-item" style="padding: 4px;"><img style="width: 100%;height: 100%;" src="../../assets/image/rubbish3.png"></div>
                  <div class="content-item">80m²</div>
                  <div class="content-item">70m²</div>
                  <div class="content-item">正常</div>
              </div>
              <div class="content-i">
                  <!-- <div class="content-item">123</div>
                  <div class="content-item">123</div>
                  <div class="content-item">123</div>
                  <div class="content-item">123</div>
                  <div class="content-item">123</div>
                  <div class="content-item">123</div> -->
              </div>
              <div class="content-i">
                  <!-- <div class="content-item">123</div>
                  <div class="content-item">123</div>
                  <div class="content-item">123</div>
                  <div class="content-item">123</div>
                  <div class="content-item">123</div>
                  <div class="content-item">123</div> -->
              </div>
              <div class="content-i">
                  <!-- <div class="content-item">123</div>
                  <div class="content-item">123</div>
                  <div class="content-item">123</div>
                  <div class="content-item">123</div>
                  <div class="content-item">123</div>
                  <div class="content-item">123</div> -->
              </div>
              <div class="content-i">
                  <!-- <div class="content-item">123</div>
                  <div class="content-item">123</div>
                  <div class="content-item">123</div>
                  <div class="content-item">123</div>
                  <div class="content-item">123</div>
                  <div class="content-item">123</div> -->
              </div>
              <div class="content-i">
                  <!-- <div class="content-item">123</div>
                  <div class="content-item">123</div>
                  <div class="content-item">123</div>
                  <div class="content-item">123</div>
                  <div class="content-item">123</div>
                  <div class="content-item">123</div> -->
              </div>
              <div class="content-i">
                  <!-- <div class="content-item">123</div>
                  <div class="content-item">123</div>
                  <div class="content-item">123</div>
                  <div class="content-item">123</div>
                  <div class="content-item">123</div>
                  <div class="content-item">123</div> -->
              </div>
            </div>
            <!-- <div class="textS">
              <span>暂无数据</span>
            </div> -->
          </div>
        </div>
      </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        center: {
          lng: 117.285033,
          lat: 31.86515
        },
        map: '',
        BMap: '',
        list:[],
      }
    },
    methods:{
      //地图展示
      handler({ BMap, map }) {
        console.log(BMap);
        console.log(map);
        this.map = map
        this.BMap = BMap
        this.map.enableScrollWheelZoom();
        // map.addControl(new BMap.ScaleControl());
      },
      change1(value){
        if(value===null){
          return
        }
        console.log(value)
      },
      enterDetails(){
        this.$router.push('/listDetails')
      }
    },
    mounted(){
      console.log(this.$route)
    }
  }
</script>

<style scoped>
.el-date-editor {
  position: absolute;
  left: 0;top: 0;
  width: 150px;
}
::v-deep .el-input__inner, ::v-deep .el-input__prefix{
  opacity: 0 !important;
  cursor: pointer;
}
.el-dropdown-menu, .el-popper{
  width: 150px;

}
.main{
  height: 90.5vh;
  overflow: auto;
  background-color: #ecf0f5;
  padding-left:5px ;
  padding-right:23px ;
}
.nav-bar{
  height: 57px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.nav-bar-l{
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: PingFang-SC-Regular;
	font-size: 18px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #000000;
}
.nav-bar-r{
  width: 340px;
  display: flex;
  justify-content: space-between;
}
.nav-bar-r>div{
  width: 150px;
  border: 0;
  background-color: #0b62f0;
  height: 40px;
  line-height: 40px;
  padding: 0 10px;
  border-radius: 6px;
  font-family: PingFang-SC-Regular;
	font-size: 18px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #ffffff;
  cursor: pointer;
}
.map{
  display: flex;
  height: 499px;
}
.map-l{
  background-color: #fff;
  height: 491px;
  width: 69.8%;
  margin-right: 0.2%;
  border-radius: 10px;
  padding: 0.5vh 0.5vw;
  box-shadow: 0px 3px 7px 0px 
		rgba(105, 159, 204, 0.35);
	border-radius: 6px;
}
.map-r{
  height: 490px;
  width: 30%;
  overflow: hidden;
  border-radius: 10px;
  box-shadow: 0px 3px 7px 0px 
		rgba(105, 159, 204, 0.35);
}
.map-r-title{
  background-color: #E6E6E6;
  line-height: 60px;
  font-family: PingFang-SC-Bold;
	font-size: 24px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #333333;
}
.map-r-content{
  height: 430px;
  overflow: scroll;
}
.map-r-content::-webkit-scrollbar{
  width: 0 !important;
  height: 0 !important;
}

.map-r-content>div{
  background-color: #fff;
  margin-bottom: 0.2vh;
  line-height: 60px;
  color: black;
  cursor: pointer;
}
.map-r-content>div:hover{
  background-color: #e1edf8;
}
.box{
  height: 50vh;
  overflow: hidden;
  border-radius: 10px;
  box-shadow: 0px 3px 10px 0px 
		rgba(105, 159, 204, 0.5);
}
.box-top{
  height: 60px;
  line-height: 60px;
  background-color: #E6E6E6;
  font-family: PingFang-SC-Bold;
	font-size: 24px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #333333;
}
.title, .content-i{
  display: flex;
}
.scroll-big{
  height: 54vh;
  overflow: scroll;
}
.scroll-big::-webkit-scrollbar{
  width: 0 !important;
  height: 0 !important;
}
.scroll{
 /* background-color: pink; */
  height: 358px;
  overflow: scroll;
}
.scroll::-webkit-scrollbar{
  width: 0 !important;
  height: 0 !important;
}
.title-item{
  font-family: PingFang-SC-Bold;
	font-size: 24px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #333333;
}
.title-item{
  flex: 1;
  height: 50px;
  line-height: 50px;
  background-color: #fff;
  border: 1px solid #D4D4D4;
}
.content-item{
  flex: 1;
  border: 1px solid #D4D4D4;
  height: 119px;
  line-height: 119px;
  font-family: PingFang-SC-Bold;
	font-size: 24px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #666666;
}
.content-i{
  background-color: #fff;
}
.content-i:hover{
  background-color: #e1edf8;
}
.item{
  display: flex;
  padding: 0 30px;
  justify-content: space-between;
  align-items: center;
  font-family: PingFang-SC-Bold;
	font-size: 24px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #333333;
}
.active{
  color: #ff1111;
}
.textS{
  background-color: #fff;
  height: 38vh;
  display: flex;
  justify-content: center;
}
.textS>span{
  font-size: 30px;
  margin-top: 5vh;
}

.textS1{
  background-color: #fff;
  height: 46vh;
  display: flex;
  justify-content: center;
}
.textS1>span{
  font-size: 21px;
  margin-top: 2vh;
}
</style>